export default function TableTitleRow({text}: any) {
  return (
    <div className="table-title-row-div">{text}</div>
  )
}
